// extracted by mini-css-extract-plugin
export default {"sort":"Sort_sort__vpg75","icon":"Sort_icon__DkBo+"};